/**
 * Unified staff search — one call replaces the navbar SearchBar's
 * three-query client merge (mobile backend-first effort). The server
 * types each result (member/customer/lead/athlete) and owns the dedupe.
 *
 * `types` scopes which people categories the server queries — the ONE
 * search endpoint every surface shares (sidebar, memberships page,
 * athletes page, duplicate-email lookups), each passing the categories
 * that belong on it. Omitted → members+customers+athletes (sidebar
 * default; leads are opt-in).
 */
import axios from "./axiosInstance";
import config from "./config";

const BASE_URL = config.BASE_URL;

export type ServerSearchType = "members" | "customers" | "leads" | "athletes";

export interface UnifiedSearchResult {
  id: string;
  type: "member" | "customer" | "lead" | "athlete";
  // Null for a lead captured without a name (AI chat, abandoned sign-up).
  first_name: string | null;
  last_name?: string | null;
  email: string | null;
  /** Memberships only — lets a nameless, email-less lead still be titled. */
  phone?: string | null;
  status?: string;
  membership_id?: string;
}

export const unifiedSearch = async (
  token: string | null,
  q: string,
  limit = 25,
  types?: ServerSearchType[]
): Promise<UnifiedSearchResult[]> => {
  const res = await axios.get(`${BASE_URL}/search`, {
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
    },
    params: {
      q,
      limit,
      ...(types && types.length > 0 ? { types: types.join(",") } : {}),
    },
  });
  return (res?.data?.data?.results || []) as UnifiedSearchResult[];
};
